import React, { Component } from "react";
import Hero from './../../alpineComponents/hero';
import CenteredParagraph from './../../alpineComponents/centeredParagraph';
import TextAndImage from './../../alpineComponents/textAndImage';
import ContactInfo from './../../components/contactInfo';
import { Link } from "react-router-dom";
import  './../../utils/analytics';


export default class extends Component {
  render() {
    return (
		<div className="light-grey-background">
      <div className="light-grey-background">
        <Hero
  				subtitle={'PILATES AVENUE'}
  				title={'Prenatal and Postnatal Pilates'}
  				backgroundImage={'images/prenatal-hero.jpg'}
          mobileImage={'images/prenatal-hero-mobile.jpg'}
  				height={'threequarter'} /*full, half,threequarter*/
          subtitlePosition={'top'}
          tint={'dark'}
        />
        <div className="small-max-width-container centered-text section-padding" style={{paddingBottom: "50px"}}>
          <CenteredParagraph
            title={"Prenatal and Postnatal Pilates"}
            description={"Workout safely before and after baby is born. Strengthen your core and pelvic floor when you need it most. Available in-studio or online from the comfort of your own home."}
          />
        </div>
        <div className="section-padding max-width-container"  style={{paddingTop:"0px"}}>
          <div className="white-background">
            <TextAndImage
              ratio={'square'}/*square, rectangle*/
              direction={'left'}/*left, right*/
              image={'images/prenatal1.jpg'}
              content={
                <div>
                  <h4>{'Before Baby'}</h4>
                  <ul style={{marginTop:'20px'}}>
                    <li className="subheading">{'Strengthen your core muscles to keep good posture as your center of gravity shifts forward. Learn how to prevent diastasis recti (separation of the abdominals).'}</li>
                    <li className="subheading">{'Protect the lower back with exercises that help to lengthen the spine as well as stabilize your pelvis in an optimal position.'}</li>
                    <li className="subheading">{'Learn and practice lateral breathing while you move. This makes space for the baby as your growing belly pushes up against the diaphragm.'}</li>
                    <li className="subheading">{'Strengthen and relax muscles of the pelvic floor, which help support the weight of the baby and play a large part in labor and delivery.'}</li>
                  </ul>
                </div>
              }
            />
            <TextAndImage
              ratio={'square'}/*square, rectangle*/
              direction={'right'}/*left, right*/
              image={'images/prenatal2.jpg'}
              content={
                <div>
                  <h4>{'Post Baby'}</h4>
                  <p className="subheading" style={{marginTop:'20px'}}>
                    {'While you\'ll have your hands full, take time to take care of you! Because it\'s true, "Ain\'t no one happy if mama ain\'t happy." Don\'t want to leave baby yet? No worries. Bring your infant with you to the studio -- available during select times, surcharge $25 per session to allow for exclusive use of the studio.'}
                  </p>
                  <ul style={{marginTop:'20px'}}>
                    <li className="subheading">{'Regain strength in the abdominals and pelvic floor after they\'ve been stretched during pregnancy.'}</li>
                    <li className="subheading">{'Stretch muscles of the chest and shoulders, which often get tight from cradling baby, breastfeeding, pushing a stroller...'}</li>
                    <li className="subheading">{'Strengthen upper back muscles to help you stand tall while holding and caring for your little one.'}</li>
                    <li className="subheading">{'Strengthen and lengthen core muscles to support you in good posture and proper alignment again.'}</li>
                  </ul>
                </div>
              }
            />
            <TextAndImage
              ratio={'square'}/*square, rectangle*/
              direction={'left'}/*left, right*/
              image={'images/prenatal3.jpg'}
              content={
                <div>
                  <h4>{'Pelvic Floor Health'}</h4>
                  <ul style={{marginTop:'20px'}}>
                    <li className="subheading">{'Strengthen pelvic floor and core muscles to support your organs and prevent or manage pelvic floor weakness.'}</li>
                  </ul>
                </div>
              }
            />
          </div>
        </div>
        <div className="max-width-container section-padding" style={{paddingTop:'0px'}}>
          <div className="small-padding primary-background shadow full-height relative centered-text">
            <h4 className="white">{'Start Your Pilates Journey'}</h4>
            <p className="white">{'Choose from a variety of class formats including online and in studio'}</p>
            <Link to="/services">
              <h6 className="button" style={{backgroundColor:'#fff',color:"#ee6725", marginTop:'40px'}}>{'View Services'}</h6>
            </Link>
          </div>
        </div>
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/formoms/index.js